import { render } from "./CsaeView.vue?vue&type=template&id=2fe5720e&ts=true"
import script from "./CsaeView.vue?vue&type=script&lang=ts"
export * from "./CsaeView.vue?vue&type=script&lang=ts"

import "./CsaeView.vue?vue&type=style&index=0&id=2fe5720e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__